import angular from 'angular';
import orderDetailComponent from './order-detail.component';
import OrderDetailService from './order-detail.service';
import orderDetailConfig from './order-detail.config';

let orderDetailModule = angular.module('app.orderDetail',[])
  .component('orderDetail', orderDetailComponent)
  .service('OrderDetailService', OrderDetailService)
  .config(orderDetailConfig);

export default orderDetailModule;



/** WEBPACK FOOTER **
 ** ./www/components/orders/order-detail/order-detail.js
 **/